import { useDateFormatter } from "@l2r-front/l2r-i18n"

import { useIsMobileDevice } from "../../hooks/useIsMobileDevice"

import { MoreMenu, MoreMenuItemConfig } from "../MoreMenu"

import * as Styled from "./CardWithThumbnail.styled"

export interface CardWithThumbnailChip {
    icon?: React.ReactElement<unknown>
    label?: string,
}

export interface CardWithThumbnailProps {
    chips: CardWithThumbnailChip[]
    children?: React.ReactNode
    date: Date | number | string
    menuConfig: MoreMenuItemConfig[]
    onClick?: () => void
    onMouseEnter?: () => void
    onMouseLeave?: () => void
    secondaryIcon: React.ComponentType
    secondaryText: React.ReactNode
    title: string
    greydOut?: boolean
}

export const CardWithThumbnail = (props: CardWithThumbnailProps) => {
    const {
        title,
        date,
        chips = [],
        onClick,
        onMouseEnter,
        onMouseLeave,
        menuConfig,
        children,
        secondaryIcon,
        secondaryText,
        greydOut = false,
    } = props

    const dateFormatter = useDateFormatter()
    const isMobile = useIsMobileDevice()

    return (
        <Styled.ListItem>
            <Styled.Card
                elevation={0}
                isMobile={isMobile}
                onClick={onClick}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                greydOut={greydOut}
            >
                {children}
                <Styled.Content>
                    <Styled.FileContent>
                        <Styled.FileName variant="Desktop & Mobile/Heading/H4">
                            {title}
                        </Styled.FileName>
                        <Styled.FileInfoContainer>
                            <Styled.FileInfo>
                                <Styled.DateIcon />
                                <Styled.FileInfoText variant="Desktop & Mobile/Body/Small">
                                    {dateFormatter(new Date(date), "d MMM yyyy")}
                                </Styled.FileInfoText>
                            </Styled.FileInfo>
                            {!!secondaryText && (
                                <>
                                    <Styled.PointSeparator>•</Styled.PointSeparator>
                                    <Styled.FileInfo>
                                        <Styled.SecondaryIcon icon={secondaryIcon} />
                                        <Styled.FileInfoText variant="Desktop & Mobile/Body/Small">
                                            {secondaryText}
                                        </Styled.FileInfoText>
                                    </Styled.FileInfo>
                                </>
                            )}
                        </Styled.FileInfoContainer>
                    </Styled.FileContent>
                    <Styled.ChipsContainer>
                        {chips.map((chip, index) => (
                            <Styled.Chip
                                key={index}
                                label={(isMobile && index === 0) ? null : chip.label}
                                variant="outlined"
                                icon={chip.icon && chip.icon}
                                iconOnly={isMobile && index === 0}
                            />
                        ))}
                    </Styled.ChipsContainer>
                </Styled.Content>
                <MoreMenu
                    menuConfig={menuConfig}
                    color="tertiary"
                    size="small"
                />
            </Styled.Card>
        </Styled.ListItem>
    )
}